import NewPaymentForm from './NewPaymentForm';

export default NewPaymentForm;
